import classNames from "classnames";
import { CompanyAccountState } from "../../types";
import {
  getCompanyStatusIndicatorColor,
  getCompanyStatusIndicatorText,
} from "../../utils/coimex-utils";

interface IProps {
  status: CompanyAccountState;
}

export default function CompanyStatusIndicator({ status }: IProps) {
  const color = getCompanyStatusIndicatorColor(status);
  return (
    <div className="flex items-center gap-1 text-xs">
      <span className="mr-1">Status</span>
      <span
        className={classNames("rounded-full", "w-2", "h-2", `bg-${color}`)}
      />
      <span className={classNames(`text-${color}`)}>
        {getCompanyStatusIndicatorText(status)}
      </span>
    </div>
  );
}
